<script>
import ProductToppingsList from '@components/product-toppings-list'

const DEFAULT_PRODUCT_IMAGE =
  'https://lupe.rappi.com/assets/images/default-product.png'

export default {
  name: 'PanelProductItem',
  components: {
    ProductToppingsList,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      isSelected: false,
      checkColor: 'success',
      isOpen: 0,
      openedPanel: null,
    }
  },
  computed: {
    productHaveImage () {
      return this.product.image.indexOf('NO-IMAGE') === -1
    },
    getProductPrice () {
      return this.product.price_details.previous_unit_price_str
    },
    hasToppings () {
      return this.product.toppings
      ? this.product.toppings.length > 0
      : false
    },
    unitText () {
      return this.product.quantity > 1
      ? this.$t('COMPONENTS.ORDER_PRODUCT.UNITS')
      : this.$t('COMPONENTS.ORDER_PRODUCT.UNIT')
    }
  },
  created () {
    if (!this.productHaveImage) this.imageFallBack()
  },
  methods: {
    imageFallBack () {
      this.product.image = DEFAULT_PRODUCT_IMAGE
      this.$forceUpdate()
    },
    onIsProductSelected ({ isSelected, checkColor, selectedProduct }) {
      this.checkColor = checkColor
      this.isSelected = isSelected
      this.$emit('productUpdate', selectedProduct)
    },
  },
}
</script>

<template>
  <div
    :id="`product-rest-${$vnode.key}`"
    :class="$style.container">
    <div :class="$style.container__product">
      <div :class="$style.container__product__image">
        <img
          :src="product.image"
          :alt="product.name"
          width="70"
          height="70"
          loading="lazy"
          @error="imageFallBack()"
        >
      </div>
    </div>
    <div :class="$style.container__actions">
      <div :class="$style.container__productActions">
        <div :class="$style.container__productActions__info">
          <h4 :class="$style.container__productActions__info__name">
            {{ product.name }}
          </h4>
          <span :class="$style.container__productActions__info__unity">
            {{ product.quantity }} {{ unitText }} · {{ getProductPrice }}
          </span>
        </div>
      </div>
      <div >
        <ProductToppingsList
          :product="product"
          :is-selected="isSelected"
          :component-data="componentData"
          @isProductSelected="onIsProductSelected"
        />
      </div>
    </div>
  </div>
</template>

<style scoped module lang="scss">
@import '@design';

.container {
  display: flex;
  justify-content: space-between;
  padding: 1rem;

  &__product {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;

    &__image {
      width: 69px;
      height: 69px;
      border-radius: 10px;
      object-fit: cover;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  &__productActions {
    display: flex;
    flex-flow: row wrap;
    flex-grow: 1;
    align-items: flex-start;
    width: 100%;
    padding: 0 0.5rem;

    &__info {
      max-width: 100%;
      height: 100%;
      padding-top: 0.5rem;
      padding-right: 0.5rem;
      overflow: hidden;
      text-align: left;
      text-transform: capitalize;
      word-wrap: break-word;

      &__name {
        font-family: 'Object Sans Heavy', sans-serif;
        font-size: 1.2rem;
        font-weight: bold;
      }

      &__unity {
        display: block;
        margin: 0.5rem 0;
        font-size: 0.9rem;
        color: $text-gray;
      }

      &__price {
        font-size: 1rem;
        color: $darker-gray;
      }
    }

    &__checkbox {
      display: flex;
      height: 100%;
      margin-right: -5px;
      margin-left: auto;
    }

    &__checkbox * {
      margin-top: 2px;
    }
  }
}
</style>
